import React, { useEffect, useState } from "react";
import { AiFillBackward } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import NewSupplier from "./NewSupplier";
import { useGetSuppliersQuery } from "../../features/api/supplierApi";
import { toast } from "react-toastify";
import {
  useAddExpenseMutation,
  useGetExpenseQuery,
} from "../../features/api/expenseApi";
import { useGetProductQuery } from "../../features/api/productApi";
import AddSubItem from "./SubItem/AddSubItem";
import AddSubItemList from "./SubItemList/AddSubItemList";
import { useGetAllModelQuery } from "../../features/api/modelApi";

const CreateExpense = () => {
  const months = [
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" },
  ];

  // fetch all suppliers
  const suppliers = useGetSuppliersQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.supplier;

  const expenses = useGetExpenseQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.expense;

  const [exp_amt, setAmount] = useState("");
  const [month, setMonth] = useState("");
  const [rmk, setRemarks] = useState("");
  const [exp_date, setExpDate] = useState("");
  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0];
    setExpDate(currentDate);
  }, []);
  const [subItemId, setSubItemId] = useState("");
  const [subItemList, setSubItemList] = useState("");

  let maxInvNo = 0;
  expenses?.map((data) => {
    const chalanNo = data?.exp_no;
    const chalanSeperate = chalanNo?.split("-")[1];
    const generateAgain = chalanSeperate?.split("/")[0];
    if (!isNaN(generateAgain) && +generateAgain > +maxInvNo) {
      maxInvNo = generateAgain;
    }
  });
  const generateInvoice = `EXP-${+maxInvNo + 1}/${new Date()
    .getFullYear()
    .toString()
    .slice(-2)}`;

  const products = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data?.filter((d) => d?.sub_catName === 10);

  const productModels = useGetAllModelQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data?.filter((d) => d?.product_id === subItemId);

  const [addNewExpense] = useAddExpenseMutation();

  const navigate = useNavigate();
  // handle function for purchase product
  const [loading, setLoading] = useState(false);
  const handleSubmit = async () => {
    setLoading(true);
    const saveData = {
      exp_no: generateInvoice,
      exp_date,
      company: "Johura Endomed Solution",
      category: 10,
      item: subItemId,
      part: subItemList,
      exp_amt,
      qty: month,
      rmk,
    };
    try {
      const response = await addNewExpense(saveData);
      if (response?.data) {
        setLoading(false);
        toast.success("Add successfull...!!!");
        navigate("/dashboard/expenses/summary");
      } else if (response?.error) {
        setLoading(false);
        toast.error("Error adding expense...!!!");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error", error?.response);
    }
  };
  return (
    <div className="h-[90vh] overflow-auto">
      <div className="flex justify-between items-center p-4">
        <div className="flex items-center gap-x-2">
          <Link
            to="/dashboard/expenses/summary"
            className=" rounded text-red-600 font-bold flex items-center gap-x-1"
          >
            <AiFillBackward /> Back{" "}
          </Link>
          <h1 className="text-xl font-bold">Create Expense</h1>
        </div>
        <div className="flex items-center gap-x-2">
          <AddSubItem />
          <AddSubItemList />
          <NewSupplier />
        </div>
      </div>
      <div>
        <div className="p-4 m-4 border">
          <form className=" grid grid-cols-2 lg:grid-cols-3  gap-6">
            <div className="flex flex-col gap-1">
              <label>Expense No.</label>
              <input
                type="text"
                value={generateInvoice}
                disabled
                className="border h-8 pl-1"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label>Date of Expense</label>
              <input
                type="date"
                value={exp_date}
                onChange={(e) => setExpDate(e.target.value)}
                className="border h-8 pl-1"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label>Company</label>
              <input
                type="text"
                value={"Johura Endomed Solution"}
                disabled
                className="border h-8 pl-1"
              />
            </div>
            {/* <div className="flex flex-col gap-1">
              <label>Category</label>
              <input
                type="text"
                defaultValue={"Expenses"}
                disabled
                className="border h-8 pl-1"
              />
            </div> */}
            <div className="flex flex-col gap-1">
              <label>Sub Item</label>
              <select
                onChange={(e) => setSubItemId(Number(e.target.value))}
                className="border h-8 pl-1"
              >
                <option value={""}>--select--</option>
                {products?.map((pro) => (
                  <option key={pro?.id} value={pro?.id}>
                    {pro?.product_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label>Sub Item List</label>
              <select
                onChange={(e) => setSubItemList(Number(e.target.value))}
                className="border h-8 pl-1"
              >
                <option value={""}>--select--</option>
                {productModels?.map((proM) => (
                  <option key={proM?.model_id} value={proM?.model_id}>
                    {proM?.model_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label> Amount</label>
              <input
                type="number"
                value={exp_amt}
                onChange={(e) => setAmount(e.target.value)}
                className="border h-8 pl-1"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label>Expense Month</label>
              <select
                onChange={(e) => setMonth(Number(e.target.value))}
                className="border h-8 pl-1"
              >
                <option>--select--</option>
                {months?.map((m) => (
                  <option key={m?.id} value={m?.id}>
                    {m?.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="font-bold">Remarks</label>
              <textarea
                onChange={(e) => setRemarks(e.target.value)}
                className="border-2 focus:outline-none"
              />
            </div>
          </form>
        </div>
        <button
          onClick={() => handleSubmit()}
          className={`bg-green-500 text-white font-bold px-4 py-1 m-4 rounded  `}
        >
          {loading ? "Loading..." : "Submit"}
        </button>
      </div>
    </div>
  );
};

export default CreateExpense;
